/**
 * Pause/play toggle for announcement marquee (WCAG 2.2.2).
 */
function initAnnouncementMarquee(root) {
  const btn = root.querySelector('[data-zoh-am-pause]');
  if (!(btn instanceof HTMLButtonElement)) return;

  const pauseIcon = btn.querySelector('[data-zoh-am-icon-pause]');
  const playIcon = btn.querySelector('[data-zoh-am-icon-play]');
  const pauseLabel = btn.dataset.labelPause || 'Pause announcements';
  const playLabel = btn.dataset.labelPlay || 'Play announcements';

  const sync = () => {
    const paused = root.classList.contains('is-paused');
    btn.setAttribute('aria-label', paused ? playLabel : pauseLabel);
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    if (pauseIcon instanceof HTMLElement) pauseIcon.hidden = paused;
    if (playIcon instanceof HTMLElement) playIcon.hidden = !paused;
  };

  btn.addEventListener('click', () => {
    root.classList.toggle('is-paused');
    sync();
  });

  sync();
}

document.querySelectorAll('[data-zoh-announcement-marquee]').forEach((el) => {
  if (el instanceof HTMLElement) initAnnouncementMarquee(el);
});
